import { darken, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    borderRadius: 24,
    height: 48,
    width: 48,
    right: 0,
    backgroundColor: 'transparent',
    transition: 'unset',
    overflow: 'hidden',
    direction: 'ltr'
  },
  rootEnabled: {
    marginLeft: 0,
    width: 144,
    height: 144,
    backgroundColor: theme.palette.primary.main,
    direction: 'rtl',
    transition: 'all 0.25s ease-out ',
    zIndex: 1200
  },
  itemsContainer: {
    width: 144,
    height: 144,
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    direction: 'ltr'
  },
  item: {
    width: 48,
    height: 48,
    borderRadius: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  itemSelected: {
    width: 48,
    height: 48,
    borderRadius: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: darken(theme.palette.primary.dark, 0.5)
    }
  },
  itemText: {
    color: '#ffffff'
  },
  itemTextSelected: {
    color: theme.palette.primary.dark
  }
}))
export default useStyles
